import * as TE from 'fp-ts/TaskEither';

import AppConfig, { isDev } from '../AppConfig';
import type { BSTask } from '../model/types';

export const debug = (message?: unknown, ...params: unknown[]): void => {
  if (isDev) {
    // biome-ignore lint/suspicious/noConsole: debug log
    console.log(message, ...params);
  }
};

export const debugIO = (message?: unknown, ...params: unknown[]): BSTask<void> =>
  TE.fromIO(() => debug(message, ...params));

export const debugHtml = (html: string): void => {
  if (AppConfig.debugHtml) {
    debug(html);
  }
};
